<template>
    <div>
      <link href="https://img2.233.com/wx/union/pc/fine/category/css/jzs1.css" rel="stylesheet" type="text/css">
        <div class="wx-header-cont" id="wx-header-cont"> 
        <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
        <div class="wx-header-container">
            <div class="fl-box">
          <h1 class="logo"> <a href="/"><img  :src="logo" > </a> </h1>
            <div class="line"></div>
            <div class="wx-subject">
                <h2>一级建造师</h2>
                <i class="dropdown-arrow"></i>
                <div class="subject-list">
                        <a href="./#/jianli">监理工程师</a>
                        <a href="./#/aq">安全工程师</a>
                        <a href="./#/cfe">一级消防工程师</a>
                        <a href="./#/zaojia">造价工程师</a>
                        <a href="./#/jzs1">一级建造师</a>
                        <a href="./#/jzs2">二级建造师</a>
                        <a href="./#/zjy">二级造价工程师</a>
                        <a href="./#/zjxfy">消防设施操作员</a>
                </div>
            </div>
            <div class="head-area  text-gry6 font14 fl m-t-10"  style="display: none;"> 当前地区
                <p class="m-l-15  bg-white fr "><em class="now-area p-0-20">全国版</em><a href="" class="more-area p-0-10">更多地区 </a></p>
                <div class="area_list">
                <ul>
                    <li><a href="/tegang/guojia/#tgtc">全国</a></li>
                    <li><a href="/tegang/shanxi1/#tgtc">陕西</a></li>
                    <li><a href="/tegang/hebei/#tgtc">河北</a></li>
                    <li><a href="/tegang/henan/">河南</a></li>
                    <li><a href="/tegang/sichuan/#tgtc">四川</a></li>
                    <li><a href="/tegang/jiangxi/#tgtc">江西</a></li>
                    <li><a href="/tegang/yunnan/#tgtc">云南</a></li>
                    <li><a href="/tegang/heilongjiang/#tgtc">黑龙江</a></li>
                    <li><a href="/tegang/chongqing/#tgtc">重庆</a></li>
                    <li><a href="/tegang/hubei/#tgtc">湖北</a></li>
                </ul>
                </div>
            </div>
            </div>
            <div class="fr-box"> 
                <!--未登录 -->
                <div class="personal-no" v-if="!isLogin">
                    <p><a target="_blank" :href="'/uc/login?redirecturl='+href" class="red">登录</a>|<a target="_blank" :href="'/uc/register?redirecturl='+href">注册</a></p>
                </div>
                <div class="personal" v-else>
                            <a href="javascript:;" class="pic"><img :src="logoSrc" ><i class="dropdown-arrow"></i></a>
                            <div class="pop-personal">
                                <a href="javascript:" @click="loginout()"><i class="icon"></i><span class="txt">退出</span></a>
                            </div>
                </div>
                <div class="classify"> 
                    <a class="classify-list" href="/shopping/cart" target="_blank" title="购课车">
                    <p class="icon shopping"></p>
                    </a> </div>
                <div v-if="kefu.length>0" class="wx-telephone">
                    <p class="txt1">客服热线</p>
                    <p class="txt2">{{kefu}}</p>
                </div>
            </div>
        </div>
        <div class="clear"></div>
        </div>
        <!--banner-->
        <div class="bg-black"> 
        <!--01banner-->
        <Banner imgUrl="https://img2.233.com/wx/union/pc/fine/category/img/jzs1/banner01.jpg"></Banner>
        <!--01banner 结束--> 
        <!---02试听区域--->
        <div class="video clearfix">
            <div class="video-layout">
            <div class="subject-tabBox clearfix" >
                <ul class="sub-tabL clearfix">
                <li class="line" @click="changeCourseIndex(i)" v-for="(v,i) in courses.slice(0,7)" :key="i">
                    <a href="javascript: void(0)"  :class="i==courseIndex?'hover':''">{{v.name}}</a>
                </li>
                </ul>
                <div class="Rselect-box" @mouseover="changeIsHoverCourse(true)" @mouseout="changeIsHoverCourse(false)" >
                <p class="subject-select currt clearfix"><span class="txt">选择其它科目</span><i class="ico"></i></p>
                <div class="sub-sel-list" v-show="isHoverCourse">
                    <ul>
                    <li v-for="(v,i) in courses.slice(7)" :key="i">
                        <a  @click="changeCourseIndex(i+7)" style="text-overflow:ellipsis; overflow:hidden; white-space:nowrap;" href="javascript: void(0)">{{v.name}}</a>
                    </li>
                    </ul>
                </div>
                </div>
            </div>
            <myvideo   :isLogin="isLogin"  :allLoginPlayFlag="allLoginPlayFlag"  :unionId="unionId" :classEname="'jzs1'" :logo="logo" :myClassId="courses[courseIndex].myClassId"></myvideo>
            </div>
            <div class="video-bottom"></div>
        </div>
        <!---02试听区域END---> 
        </div>
        <!--03原高级平台班级对比-->
        <banjiduibi :calssName="'一级建造师'" :classEName="'jzs1'"></banjiduibi>
        <!--03原高级平台班级对比 end--> 
            
        <!--04全部班级表格-->
        <quanbubanji :classEname="'jzs1'"></quanbubanji>
        <!--04全部班级表格 end--> 

        <!--06套用官网内容  开始-------------> 
        <!--证书价值-->
        <div class="modular-mian modular-zsjz" id="zxjz"> 
        <!--标题-->
        <div class="headbox headbox02 clearfix">
            <h2 class="head-title"><i class="lf-decorate lf-decorate02"></i><em class="lf-blue">证书</em><em class="rt-white rt-white02">价值</em><i class="rt-decorate rt-decorate02"></i></h2>
            <span class="head-content head-content02">建筑业抢手人才，前途和&ldquo;钱途&rdquo;一片光明</span> </div>
        
        <!--标题 end-->
        <div class="zs-vs">
            <div class="zs-vs-mian clearfix">
            <div class="zs-vs-bt"><span class="vs-theme"><font>无</font>一建证书</span><i></i><em class="vs-theme-bg"></em><span class="vs-theme vs-theme02"><font>有</font>一建证书</span><i class="xian02"></i></div>
            <ul class="zs-vs-txt">
                <li class="li-gray01"><i></i><font>建筑工人：</font>3K-5K/月</li>
                <li class="li-gray02"><i></i><font>施工工人：</font>3K-5K/月</li>
                <li class="li-gray04"><i></i><font>想跳槽：</font>底气不足</li>
            </ul>
            <ul class="zs-vs-txt zs-vs-txt02">
                <li class="li-gules01"><i></i><font>副总经理：</font>30K-50K元/月</li>
                <li class="li-gules02"><i></i><font>高级工程管理经理：</font>40k-60K元/月</li>
                <li class="li-gules04"><i></i><font>想跳就跳：</font>走哪都是香饽饽</li>
            </ul>
            </div>
        </div>
        <div class="zs-baokao" >
            <div class="zs-bk-main"> <i></i>
            <div class="zs-bk-txt">建筑从业人员至少4600万，而一级建造师仅50多万，加上市场逐步规范，每个只能接受一个单位聘请且通过率逐年降低，使得一建证书含金量大大增加，<font>谁先拿到证书，谁就是赢家！</font></div>
            <div class="zs-bk-icon" @click="scroll(900)"><a href="javascript:">我要报考</a></div>
            </div>
        </div>
        </div>
        <!--证书价值 end--> 

        <!--师资团队-->
        <div class="modular-mian modular-team" id="sztd"> 
        <!--标题-->
        <div class="headbox clearfix">
            <h2 class="head-title"><i class="lf-decorate"></i><em class="lf-blue">师资</em><em class="rt-white">团队</em><i class="rt-decorate"></i></h2>
            <span class="head-content">一线师资团队陪你奋战到底</span> </div>
        <!--标题 end-->
        <div class="team-mian">
            <div class="careerbox">
                <ul class="g-clr clearfix">
                    <li :class="laoshiindex==0?'jx current':'jx'" @click="changelaoshiindex(0)"> <span class="switch-bg"><a><span>赵春晓</span>
                        <p>教学方式独特<br>
                            通俗易懂</p>
                        </a><a href="javascript:;" class="careerswitch"><span></span>
                        <p><br>
                        </p>
                        </a></span>
                        <div class="career_bg">
                            <div class="malebg"></div>
                            <div class="femalebg"><img class="lazy"  src="https://img2.233.com/wx/union/pc/pupage/img/jzs1/ms-hmf.png" style="display: block"></div>
                            <div class="career_detail">
                            <div class="detail-img"><span></span>
                                <h6>赵春晓</h6>
                                <p>教学方式独特，通俗易懂</p>
                            </div>
                            <div class="sexswitch"><a href="javascript:void(0);" data-type="{'TeacherID':'726','title':'赵春晓'}" node-type="menu-wx-popup-kc"><i></i>点击试听</a></div>
                            <div class="more-button">
                                <dt><em>主讲课程</em><span>建设工程项目管理</span></dt>
                                <dt><em>专业背景</em><span>工程管理硕士，一级建造师<br>
                                985师范大学毕业</span></dt>
                            </div>
                            </div>
                        </div>
                    </li>
                    <li :class="laoshiindex==1?'mg current':'mg'" @click="changelaoshiindex(1)">
                        <span class="switch-bg"><a><span>宋协清</span><p>善于分析<br>答题规律</p></a><a href="javascript:;" class="careerswitch"><span></span><p><br></p></a></span>
                        <div class="career_bg">
                            <div class="malebg"></div>
                            <div class="femalebg"><img class="lazy"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs1/ms-ljh.png" style="display: block"></div>
                            <div class="career_detail">
                            <div class="detail-img">
                                <h6>宋协清</h6>
                                <p>善于分析答题规律</p>
                            </div>
                            <div class="sexswitch"><a href="javascript:void(0);" data-type="{'TeacherID':'148','title':'宋协清'}" node-type="menu-wx-popup-kc"><i></i>点击试听</a></div>
                            <div class="more-button">
                                <dt><em>主讲课程</em><span>建筑工程</span></dt>
                                <dt><em>专业背景</em><span>博士、985名校讲师</span></dt>
                            </div>
                            </div>
                        </div>
                    </li>
                    <li :class="laoshiindex==2?'mj current':'mj'" @click="changelaoshiindex(2)"> 
                        <span class="switch-bg"><a><span>凌平平</span><p>善于分类<br>总结考点</p></a><a href="javascript:;" class="careerswitch"><span></span><p><br></p></a></span>
                        <div class="career_bg">
                            <div class="malebg"></div>
                            <div class="femalebg"><img class="lazy" src="https://img2.233.com/wx/union/pc/pupage/img/jzs1/ms-lpp.png" style="display: block"></div>
                            <div class="career_detail">
                            <div class="detail-img">
                                <h6>凌平平</h6>
                                <p>善于分类总结考点</p>
                            </div>
                            <div class="sexswitch"><a  href="javascript:void(0);" data-type="{'TeacherID':'219','title':'凌平平'}" node-type="menu-wx-popup-kc"><i></i>点击试听</a></div>
                            <div class="more-button">
                                <dt><em>主讲课程</em><span>市政工程</span></dt>
                                <dt><em>专业背景</em><span>高校副教授，一级建造师</span></dt>
                            </div>
                            </div>
                        </div>
                    </li>
                    <li :class="laoshiindex==3?'ds current':'ds'" @click="changelaoshiindex(3)"> 
                        <span class="switch-bg"><a><span>郭炜</span><p>逻辑性强、重点突出<br>深入浅出</p></a><a href="javascript:;" class="careerswitch"><span></span><p><br></p></a></span>
                        <div class="career_bg">
                            <div class="malebg"></div>
                            <div class="femalebg"><img class="lazy"  src="https://img2.233.com/wx/union/pc/pupage/img/jzs1/ms-hy.png" style="display: block"></div>
                            <div class="career_detail">
                            <div class="detail-img">
                                <h6>郭炜</h6>
                                <p>逻辑性强、重点突出、深入浅出</p>
                            </div>
                            <div class="sexswitch"><a   href="javascript:void(0);" data-type="{'TeacherID':'727','title':'郭炜'}" node-type="menu-wx-popup-kc"><i></i>点击试听</a></div>
                            <div class="more-button">
                                <dt><em>主讲课程</em><span>市政工程</span></dt>
                                <dt><em>专业背景</em><span>土木工程专业博士，全国一级建造师，注册造价工程师</span></dt>
                            </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        <div class="g-jiabing clearfix">
            <ul class="m-jiabing-ul m-jiabing-ul0">
                <li class="u-photos-cg-qt">
                    </li>
                    <li class="u-photos-cg-0">
                    <div class="spr-bg-kd u-jiabing-dhk ">谷永生<br>
                        授课：民航机场工程</div>
                    </li>
                    <li class="u-photos-cg-1">
                    <div class="spr-bg-kd u-jiabing-dhk">刘丹<br>
                        授课：建设工程法规</div>
                    </li>
                    <li class="u-photos-cg-2">
                    <div class="spr-bg-kd u-jiabing-dhk">王克<br>
                        授课：机电工程</div>
                    </li>
                    <li class="u-photos-cg-4">
                    <div class="spr-bg-kd u-jiabing-dhk">王东兴<br>
                        授课：工程经济</div>
                    </li>
                    <li class="u-photos-cg-7">
                    <div class="spr-bg-kd u-jiabing-dhk">杨鹏<br>
                        授课：通信与广电</div>
                    </li>
                    <li class="u-photos-cg-5 u-right0">
                    <div class="spr-bg-kd u-jiabing-dhk">赵景满<br>
                        授课：矿业工程</div>
                    </li>
                    <li class="u-photos-cg-6">
                    <div class="spr-bg-kd u-jiabing-dhk">安慧<br>
                        授课：公路工程</div>
                    </li>
                
                    <li class="u-photos-cg-9">
                    <div class="spr-bg-kd u-jiabing-dhk">汪兴毅<br>
                        授课：建设工程法规</div>
                    </li>
                    <li class="u-photos-cg-10">
                    <div class="spr-bg-kd u-jiabing-dhk">魏国安<br>
                        授课：工程经济</div>
                    </li>
                    <li class="u-photos-cg-12 u-right0">
                    <div class="spr-bg-kd u-jiabing-dhk">陈冬铭<br>
                        授课：港口与航道工程</div>
                    </li>
                </ul>
            <ul>
                <li class="f_clear">
                </li>
            </ul>
            </div>
        </div>
        </div>
        <!--师资团队 end--> 

        <!--网校学PK自学-->
        <div class="modular-mian modular-zxvswk" id="zxvswk"> 
        <!--标题-->
        <div class="headbox headbox02 clearfix">
            <h2 class="head-title"><i class="lf-decorate lf-decorate02"></i><em class="rt-white rt-white02">自学</em><em class="lf-blue">PK</em><em class="rt-white rt-white02">网课</em><i class="rt-decorate rt-decorate02"></i></h2>
            <span class="head-content head-content02">500名一建考生调查，告诉你正确的学习方式</span> </div>
        <!--标题 end-->
        <div class="pk-box clearfix">
            <div class="pk-box-hd"><img src="https://img2.233.com/wx/union/pc/pupage/img/jzs1/wx-pk-bg.png"></div>
            <ul class="pk-box-txt clearfix">
            <li class="pk-zx-fl">
                <h4 class="pkh4"><i></i>时间对比<i class="pk-i-rt"></i></h4>
                <div class="pk-time-box"><em class="pk-time-txt">网校</em><em class="pk-time-txt02">自学</em><span class="pk-wxx"></span><span class="pk-zx"></span></div>
                <p class="pk-li-txt"><font>1个考点</font>网校要节省5倍时间<i></i></p>
            </li>
            <li class="pk-zx-fl">
                <h4 class="pkh4"><i></i>掌握程度对比<i class="pk-i-rt"></i></h4>
                <div class="pk-time-box pk-time-box02"><em class="pk-time-txt">网校</em><em class="pk-time-txt02">自学</em><span class="pk-wxx pk-wxx02"></span><span class="pk-zx pk-zx02"></span></div>
                <p class="pk-li-txt"><font>花同样的时间</font>掌握更多考点<i></i></p>
            </li>
            <li class="pk-zx-fl pk-zx-fl03">
                <h4 class="pkh4"><i></i>通过率对比<i class="pk-i-rt"></i></h4>
                <div class="pk-time-box pk-time-box03"><em class="pk-time-txt">网校</em><em class="pk-time-txt02">自学</em><span class="pk-wxx pk-wxx03"></span><span class="pk-zx pk-zx03"></span></div>
                <p class="pk-li-txt"><font>网校</font>给你短期过4科的信心<i></i></p>
            </li>
            </ul>
            <!-- <div class="pk-icon"><a href="#tgtc">立即报课</a></div>--> 
        </div>
        <!--02网校学PK自学 end--> 
        </div>

        <!--06套用官网内容  end-------------> 
        <!--05服务特色标题-->
        <div class="main-title f-tac m-b-30 p-t-50" >
        <p class="font-bg">CHARACTERISTIC</p>
        <h2 class="font44 fb">选择我们的<em class="text-red fb">四大理由</em></h2>
        <p class="font17 text-gry-6 lh2">服务保障，学习无忧，通关指日可待</p>
        </div>
        <div class="fuwu-bg ">
        <div class="fuwu-content">
            <div class="fuwu-box">
            <ul class="clearfix m-b-20">
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">1</span>课程品质高</h4>
                <p class="font15 lh2 p-15">课程专业的教研团队精心打造，<em class="text-red fb">每个课程均经过20+次以上迭代</em>。</p>
                </li>
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">2</span>老师实力强</h4>
                <p class="font15 lh2 p-15">网校执行严格的<em class="text-red fb">师资淘汰制，由购课学员评分</em>，努力建设零差评老师团队。</p>
                </li>
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">3</span>学习服务优</h4>
                <p class="font15 lh2 p-15">您在学习课程中遇到任何问题，可在线提问，专业老师<em class="text-red fb">24小时内为您答疑解惑</em>。</p>
                </li>
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">4</span>售后服务好</h4>
                <p class="font15 lh2 p-15">部分套餐课程享<em class="text-red fb">超长有效期</em>，课程有效期内考试<em class="text-red fb">不过免费重学</em>保障。</p>
                </li>
            </ul>
            </div>
        </div>
        </div>
        <!--05服务特色 end--> 
    </div>
</template>
<script>
import myvideo from '@/components/myvideo'
import banjiduibi from '@/components/banjiduibi'
import quanbubanji from '@/components/quanbubanji'
import { getMemberPicpath } from '@/request/request.js'
export default {
  name: 'App',
  components: {
    banjiduibi,
    quanbubanji,
    myvideo
  },  
  data() {
    return {
      laoshiindex:0,
      isLogin:false,
      logoSrc:"",
      allLoginPlayFlag:false,
      unionId:"",
      kefu:"",
      logo:"",
      href:"",
      courses:[
        {name:'建筑工程',myClassId:29669},
        {name:'水利水电',myClassId:29673},
        {name:'矿业工程',myClassId:29674},
        {name:'通信工程',myClassId:29675},
        {name:'铁路工程',myClassId:29676},
        {name:'公路工程',myClassId:29672},
        {name:'机电工程',myClassId:29671},
        {name:'市政工程',myClassId:29670},
        {name:'港口与航道工程',myClassId:29678},
        {name:'建设工程项目管理',myClassId:29667},
        {name:'建设工程法规及相关知识',myClassId:29668},
        {name:'建设工程经济',myClassId:29666},
        {name:'民航工程',myClassId:29677},
      ],
      courseIndex:0,
      isHoverCourse:false,
    };
  },
  created(){
    this.href=encodeURIComponent(window.location.href);
    var config=JSON.parse(sessionStorage.getItem(window.location.host+"puconfig"));
    if(config.KefuTelList.length>0){
      this.kefu=config.KefuTelList[0].KefuNumber;
    }
    this.unionId=config.UnionId
    this.logo=config.UnionLogo;
    this.allLoginPlayFlag=config.AllLoginPlayFlag;
    var token = localStorage.getItem("usertoken");
    if(token!=undefined){
        this.isLogin=true;
        getMemberPicpath({},(res)=>{
            this.logoSrc=res;
        });
    }else{
        var interval= setInterval(() => {
        token = localStorage.getItem("usertoken");
        if(token!=undefined){
          this.isLogin=true;
          getMemberPicpath({},(res)=>{
            this.logoSrc=res;
          });
          clearInterval(interval);
        }
      }, 200);
    }
  },
  methods:{
      loginout(){
          this.isLogin=false;
          this.logoSrc="";
          localStorage.removeItem("usertoken");
      },
      scroll(num){
        document.documentElement.scrollTop=num;
      },
     changeCourseIndex(i){
       this.courseIndex=i;
     },
    changeIsHoverCourse(flag){
      this.isHoverCourse=flag;
    },
    changehoverindex(i){
      this.hoverindex=i;
    },
    changelaoshiindex(i){
      this.laoshiindex=i;
    },
  },
}
</script>